export default __webpack_public_path__ + "static/media/404-NotFound.bab47c74.png";